<template>
  <div
          class="profile"
          :class="[
    {
      'profile--loading': isProfileLoading,
      'profile--blue': isUserRole([
        UserRole.SALES_REP,
        UserRole.ADMIN,
        UserRole.CLIENT,
      ]),
    },
    {
      'is-info': props.isInfo,
    },
  ]">
      <template
              v-if="!(Object.keys(props.userProfileData)?.length === 0 && props.userProfileData.constructor === Object)">
          <div class="profile__header">
              <div v-if="!props.isInfo" class="profile__line">
                  <template v-if="props.showAs === ShowAs.SALES_REP">
                      <BlueLine/>
                      <div>
                          <p v-if="props.userProfileData.salesRepData?.title">
                              {{ props.userProfileData.salesRepData?.title }}
                          </p>
                          <p v-else-if="props.userProfileData?.title">
                              {{ props.userProfileData?.title }}
                          </p>
                          <p v-else>{{ $t('SALES_REP') }}</p>
                      </div>
                  </template>
                  <template v-if="props.showAs === ShowAs.CLIENT">
                      <BlueLine/>
                      <p v-if="[ShowAs.SALES_REP, ShowAs.CLIENT, ShowAs.MANAGER].includes(props.viewFrom)">
                          {{ $t('BUYER') }}</p>
                      <p v-else>{{ $t('MY_PROFILE') }}</p>
                  </template>
                  <template v-if="props.showAs === ShowAs.MANAGER">
                      <OrangeLine/>
                      <p>{{ $t('MANAGER_PROFILE') }}</p>
                  </template>
                  <template v-if="props.showAs === ShowAs.ADMIN">
                      <OrangeLine/>
                      <p>{{ $toast('ADMIN_PROFILE') }}</p>
                  </template>
              </div>
              <div class="profile__img">
                  <ClientOnly>
                  <AvatarComponent
                          :model-value="props.userProfileData.avatar ?? userAvatar"
                          :edit-mode="profileEditMode"/>
                  </ClientOnly>
              </div>
              <div class="profile__name">
                  <p>{{ `${props.userProfileData?.firstName} ${props.userProfileData?.lastName}` }}</p>
              </div>
              <div class="profile__desc">
                  <p v-html="props.userProfileData?.description">
                  </p>
              </div>
              <div class="profile__header--phone"
                   v-if="props.userProfileData?.phone || props.userProfileData?.phoneNumber">
                  <a class="flex gap-4 items-center"
                     :href="`tel:${props.userProfileData?.phone || props.userProfileData?.phoneNumber}`">
                      <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="28"
                              height="28"
                              viewBox="0 0 28 28"
                              fill="none">
                          <path
                                  d="M5.8865 18.544L5.88625 18.5437C3.68443 15.8982 2.19772 13.4163 1.21166 10.74C0.568917 9.00899 0.316633 7.56551 0.425164 6.2003L0.425215 6.19966C0.517716 5.09545 0.964072 4.13927 1.74981 3.35353L3.84223 1.26111L3.84476 1.25857L3.84479 1.25861C4.46652 0.66593 5.18478 0.35 5.94 0.35C6.69993 0.35 7.41278 0.665237 8.01283 1.25298C8.39586 1.60795 8.78368 2.00144 9.15265 2.3816C9.15267 2.38161 9.15268 2.38163 9.1527 2.38165L9.16768 2.39707C9.35272 2.58755 9.53201 2.77212 9.72179 2.9619L11.3885 4.62863C11.3886 4.6287 11.3887 4.62877 11.3887 4.62884C12.0211 5.25547 12.3617 5.99135 12.3617 6.74927C12.3617 7.50782 12.015 8.24348 11.389 8.86943C11.2154 9.04302 11.0429 9.21558 10.876 9.38798L10.8755 9.3885C10.4239 9.85072 9.95476 10.3256 9.45519 10.7823C9.821 11.6001 10.3393 12.4129 11.1034 13.3802C12.678 15.3107 14.3221 16.8095 16.13 17.9575L16.1301 17.9576C16.3075 18.0704 16.5081 18.1737 16.7321 18.2856L16.7338 18.2865C16.8803 18.3597 17.0373 18.4382 17.1933 18.5242L19.1157 16.6018C19.7261 15.9914 20.4508 15.6571 21.2135 15.6571C21.976 15.6571 22.6957 15.9913 23.29 16.6084C23.2903 16.6087 23.2906 16.6091 23.2909 16.6094L26.6513 19.9698C27.2766 20.595 27.5973 21.3268 27.5988 22.0721C27.6003 22.8171 27.2828 23.558 26.6648 24.2022C26.6647 24.2022 26.6647 24.2023 26.6647 24.2023L26.5565 24.0984C26.2991 24.367 26.0306 24.6299 25.7676 24.8817L5.8865 18.544ZM5.8865 18.544C8.56299 21.7434 11.7856 24.2632 15.4639 26.0461L15.4651 26.0467C16.8617 26.7085 18.7461 27.5023 20.8514 27.6385L20.8514 27.6385L20.8545 27.6387L20.8712 27.6394C20.9934 27.6447 21.1147 27.65 21.2415 27.65C22.6736 27.65 23.8322 27.1534 24.7732 26.133C24.7786 26.1278 24.7954 26.1107 24.8104 26.0879C25.1054 25.7331 25.4382 25.4102 25.794 25.0651C25.8198 25.04 25.8458 25.0149 25.8718 24.9896L5.8865 18.544ZM6.84007 2.46258L6.83995 2.4627L6.84517 2.46753C7.16737 2.76569 7.47284 3.07629 7.7972 3.4061C7.84684 3.45657 7.89692 3.50749 7.94757 3.55889C8.04301 3.65713 8.13978 3.75531 8.2368 3.85373L8.23875 3.8557C8.33538 3.95372 8.43227 4.052 8.5291 4.1516L8.52909 4.15161L8.53058 4.1531L10.1978 5.82032C10.5289 6.15142 10.6798 6.46798 10.6798 6.76046C10.6798 7.05295 10.5289 7.36951 10.1978 7.70061C10.1107 7.78772 10.0236 7.87617 9.93709 7.96412L9.9368 7.96441L9.93673 7.96448C9.84997 8.05264 9.76369 8.14031 9.67749 8.22651L9.67693 8.22708C9.63783 8.26659 9.59896 8.30592 9.56026 8.34507C9.08275 8.82812 8.63263 9.28345 8.13999 9.71965L8.13981 9.71944L8.13336 9.72589L8.11937 9.73987L8.10539 9.75386C7.85185 10.0074 7.73695 10.2641 7.70661 10.5109C7.67674 10.7539 7.7307 10.9732 7.78941 11.1494C7.79362 11.162 7.79781 11.1725 7.80054 11.1793L7.80084 11.18C7.80196 11.1829 7.80284 11.1851 7.80357 11.1869C7.80469 11.1898 7.80545 11.1919 7.8062 11.1941L7.80582 11.1943L7.81002 11.2043C8.24738 12.2551 8.85413 13.2517 9.79484 14.4346L9.79483 14.4346L9.79572 14.4357C11.4827 16.5164 13.2622 18.1334 15.2243 19.3795C15.4318 19.5146 15.652 19.6259 15.8559 19.729C15.8966 19.7495 15.9366 19.7698 15.9757 19.7898L15.9769 19.7904C16.2009 19.9024 16.4016 20.0056 16.5789 20.1185L16.5854 20.1226L16.5924 20.1261C16.5993 20.1296 16.6057 20.1332 16.6158 20.1389L16.6166 20.1394C16.6259 20.1447 16.6385 20.1519 16.6531 20.1592C16.8563 20.2638 17.0585 20.3154 17.2637 20.3154C17.7764 20.3154 18.1055 19.9889 18.2033 19.891L20.2958 17.7986C20.6022 17.4922 20.9187 17.3446 21.2135 17.3446C21.5767 17.3446 21.8864 17.5712 22.0939 17.7946L22.0938 17.7946L22.0978 17.7987L25.4713 21.1666C25.4713 21.1666 25.4714 21.1666 25.4714 21.1667C25.7881 21.4834 25.9291 21.7966 25.9267 22.0992C25.9243 22.4031 25.7772 22.7278 25.4524 23.0658L25.4509 23.0674C25.2189 23.3159 24.9752 23.5542 24.7128 23.8055L24.712 23.8062C24.6902 23.8274 24.6683 23.8486 24.6464 23.8699C24.2766 24.2289 23.8882 24.6058 23.5346 25.0287C22.9217 25.6882 22.1966 25.9961 21.2471 25.9961C21.1571 25.9961 21.0607 25.9908 20.9654 25.9852C19.1607 25.8695 17.4762 25.1644 16.1983 24.5562C12.7381 22.8816 9.70048 20.5061 7.17963 17.49C5.10151 14.9884 3.70704 12.6644 2.78539 10.1771L2.7852 10.1766C2.2138 8.65098 2.00223 7.43762 2.08926 6.34237C2.15341 5.6332 2.42364 5.04532 2.93542 4.53354L5.01571 2.45325C5.31967 2.16013 5.64185 2.0207 5.94 2.0207C6.23087 2.0207 6.54133 2.1586 6.84007 2.46258Z"
                                  fill="#353535"
                                  stroke="#353535"
                                  stroke-width="0.3"/>
                      </svg>
                      <div v-if="profileEditMode" class="border border-black rounded-lg">
                          <input
                                  v-model="userPhone"
                                  type="text"
                                  class="bg-transparent w-full"/>
                      </div>
                      <p v-else>
                          {{ props.userProfileData?.phone || props.userProfileData?.phoneNumber }}
                      </p>
                  </a>
              </div>
          </div>
      </template>
      <template v-else-if="userInfo !== null">
          <div class="profile__header">
            <div class="absolute" v-if="isVerified" style="top:5px;right:10px">
              <img src="/assets/img/icons/verified.png" alt="verified" style="width:110px; height:110px">
            </div>
              <div v-if="!props.isInfo" class="profile__line">
                  <template v-if="props.showAs">
                      <template v-if="props.showAs === UserRole.SALES_REP">
                          <BlueLine/>
                          <div
                                  v-if="profileEditMode"
                                  class="border border-black rounded-lg">
                              <input v-model="salesRepTitle" type="text"/>
                          </div>
                          <div v-else>
                              <p v-if="userInfo.salesRepData?.title">
                                  {{ userInfo.salesRepData?.title }}
                              </p>
                              <p v-else-if="props.profileData?.title">
                                  {{ props.profileData?.title }}
                              </p>
                              <p v-else>{{ $t('SALES_REP') }}</p>
                          </div>
                      </template>
                  </template>
                  <template v-else>
                      <template v-if="isUserRole(UserRole.CLIENT)">
                          <BlueLine/>
                          <p>{{ $t('MY_PROFILE') }}</p>
                      </template>
                      <template v-if="isUserRole(UserRole.SALES_REP)">
                          <BlueLine/>
                          <p>{{ $t('SALES_REP') }}</p>
                      </template>
                      <template v-if="isUserRole(UserRole.MANAGER)">
                          <OrangeLine/>
                          <ProfileBadge v-if="profileEditMode" :user-info="userInfo" />
                          <p v-else>{{ companyBadge ? companyBadge[currentLocale] : '' }}</p>
                      </template>
                      <template v-if="isUserRole(UserRole.ADMIN)">
                          <OrangeLine/>
                          <p>{{ $toast('ADMIN_PROFILE') }}</p>
                      </template>
                  </template>
              </div>

              <div class="profile__img">
                  <ClientOnly>
                  <AvatarComponent
                          v-if="props.profileData"
                          v-model="userAvatarFromProps"
                          :edit-mode="profileEditMode"/>

                  <AvatarComponent
                          v-else
                          v-model="userAvatar"
                          :edit-mode="profileEditMode"/>
                  </ClientOnly>
              </div>
              <div v-if="isUserRole(UserRole.CLIENT)" class="profile__name">
                  <div v-if="profileEditMode" class="border border-black rounded-lg">
                      <input v-model="userName" type="text"/>
                  </div>
                  <div v-else>
                      <template
                              v-if="props.profileData?.companyData?.name && isUserRole(UserRole.CLIENT) && props.showAs !== UserRole.SALES_REP">
                          <p>{{ props.profileData?.companyData?.name }}</p>
                      </template>
                      <template v-else-if="props.profileData?.companyName">
                          <p>{{ props.profileData.companyName }}</p>
                      </template>

                      <template v-else-if="props.profileData?.name">
                          <p>
                              {{ `${props.profileData?.name}` }}
                          </p>
                      </template>
                      <template
                              v-else-if="
              props.profileData?.firstName && props.profileData?.lastName
            ">
                          <p>
                              {{
                                  `${props.profileData?.firstName} ${props.profileData?.lastName}`
                              }}
                          </p>
                      </template>
                      <template v-else>
                          <p></p>
                      </template>
                  </div>
              </div>
              <div v-else class="profile__name">
                  <template v-if="props.isInfo">
                      <p>
                          {{
                              props.profileData?.companyName ||
                              props.profileData?.name ||
                              `${props.profileData?.firstName} ${props.profileData?.lastName}` ||
                              ''
                          }}
                      </p>
                  </template>
                  <template v-else>
                      <div v-if="profileEditMode" class="border border-black rounded-lg">
                          <input v-model="userName" type="text"/>
                      </div>
                      <p v-else>{{ userName }}</p>
                  </template>
              </div>

              <template v-if="props.isInfo">
                  <div class="profile__company">
                      <p>
                          {{
                              $t('TEAM_COUNT', {
                                  n:
                                          props.profileData?.companyData?.teamSize ||
                                          props.profileData?.team?.list?.length ||
                                          props.profileData?.teamSize ||
                                          props.profileData?.salesReps?.length ||
                                          0,
                              })
                          }}
                          {{ $t('ON_EASLY') }}
                      </p>
                  </div>

                  <div class="profile__opinion">
                      <RatingIcon/>
                      <div class="opinion-left">
                          <p>
                              {{
                                  props.profileData?.companyData?.rating?.toFixed(1) ||
                                  props.profileData?.rating?.toFixed(1) ||
                                  'Brak ocen'
                              }}
                          </p>
                      </div>
                      <div class="opinion-right">
                          <p>
                              {{
                                  $t('OPINION_SIZE', {
                                      n:
                                              props.profileData?.companyData?.opinions ||
                                              props.profileData?.companyData?.opinionsCount ||
                                              props.profileData?.opinionsCount ||
                                              props.profileData?.opinions?.length ||
                                              0,
                                  })
                              }}
                          </p>
                      </div>
                  </div>
              </template>
              <template
                      v-else-if="
          isUserRole(UserRole.MANAGER) || isUserRole(UserRole.SALES_REP)
        ">
                  <div v-if="isUserRole(UserRole.MANAGER)" class="profile__company">
                      <p>
                          {{ $t('TEAM_COUNT', {n: userInfo?.team?.length || 0}) }}
                          {{ $t('ON_EASLY') }}
                      </p>
                  </div>
                  <div
                          v-else-if="isUserRole(UserRole.SALES_REP)"
                          class="profile__company">
                      <p></p>
                  </div>
                  <div class="profile__opinion" v-if="props.showAs !== ShowAs.CLIENT">
                      <RatingIcon/>
                      <template v-if="props.showAs === UserRole.SALES_REP">
                          <div class="opinion-left">
                              <p>
                                  {{ salesRepCompanyData.rating?.toFixed(1) || 'Brak ocen' }}
                              </p>
                          </div>
                          <div class="opinion-right">
                              <p>{{ salesRepCompanyData.opinions || 0 }} opinii</p>
                          </div>
                      </template>
                      <template v-else>
                          <div class="opinion-left">
                              <p>{{ userInfo?.companyData?.rating?.toFixed(1) || 'Brak ocen' }}</p>
                          </div>
                          <div class="opinion-right">
                              <p>{{ userInfo?.companyData?.opinions || 0 }} opinii</p>
                          </div>
                      </template>
                  </div>
              </template>

              <template v-else>
                  <div class="profile__company">
                      <p>
                          {{ props.profileData?.companyData?.name }}
                      </p>
                  </div>
                  <div class="profile__opinion">
                      <div v-if="props.showAs === UserRole.SALES_REP">
                          <RatingIcon/>
                      </div>
                      <div v-if="props.showAs === UserRole.MANAGER">
                          <RatingIcon/>
                      </div>
                      <div class="opinion-left">
                          <p v-if="props.showAs === UserRole.SALES_REP">
                              {{
                                  props.profileData?.rating?.toFixed(1) ||
                                  $t('NO_RATINGS')
                              }}
                          </p>
                          <p v-if="props.showAs === UserRole.MANAGER">
                              {{
                                  props.profileData?.companyData?.rating?.toFixed(1) ||
                                  $t('NO_RATINGS')
                              }}
                          </p>
                      </div>
                      <div class="opinion-right">
                          <p v-if="props.showAs === UserRole.SALES_REP">
                              {{
                                  $t('OPINION_SIZE', {
                                      n: props.profileData?.opinions?.length || 0,
                                  })
                              }}
                          </p>
                          <p v-if="props.showAs === UserRole.MANAGER">
                              {{
                                  $t('OPINION_SIZE', {
                                      n: props.profileData?.companyData?.opinions || 0,
                                  })
                              }}
                          </p>
                      </div>
                  </div>
              </template>

              <template v-if="props.isInfo">
                  <div
                          class="profile__desc"
                          style="text-overflow: ellipsis; margin: 0 20px">
                      <p v-html="$props.profileData?.companyData?.description || props.profileData?.description">
                      </p>
                  </div>
              </template>
              <template v-else>
                  <div
                          v-if="isUserRole([UserRole.MANAGER, UserRole.SALES_REP])"
                          class="profile__desc">
                      <div v-if="profileEditMode" class="border border-black rounded-lg">
                          <ClientOnly>
                              <TextEditor v-model="userDescription" :initOptions="{ height: 350 }" class="bg-transparent w-full" />
                          </ClientOnly>
                      </div>
                      <p v-else>
                          <p v-html="userDescription"></p>
                      </p>
                  </div>
                  <div v-else class="profile__desc">
                      <p v-html="props.profileData?.description">
                      </p>
                  </div>
              </template>

              <template v-if="!isUserRole(UserRole.ADMIN)">
                  <div
                          v-if="
            !profileEditMode &&
            socialLinks.filter((s: any) => !!s._id)?.length > 0
          "
                          class="profile__social"
                          :class="[
            { 'profile__social--sales-rep': isUserRole(UserRole.SALES_REP) },
          ]">
                      <template
                              v-for="socialLink in socialLinks"
                              :key="`social_${socialLink.type}`">
                          <ProfileLink
                                  v-if="(socialLink as any)._id"
                                  v-model="socialLink.link"
                                  @link-error="addLinkError"
                                  @link-error-remove="removeLinkError"
                                  :icon="`/img/socials/${socialLink.type?.toLowerCase()}.svg`"
                                  :edit-mode="profileEditMode"
                                  type="social"/>
                      </template>
                  </div>
              </template>

              <div v-if="!isUserRole(UserRole.ADMIN)" class="profile__footer px-5">
                  <template v-if="profileEditMode">
                      <ProfileLink
                              v-for="socialLink in socialLinks"
                              :key="`social_${socialLink.type}`"
                              v-model="socialLink.link"
                              :icon="`/img/socials/${socialLink.type?.toLowerCase()}.svg`"
                              :edit-mode="profileEditMode"
                              @link-error="addLinkError"
                              @link-error-remove="removeLinkError"
                              type="social"/>
                  </template>

                  <template v-if="props.profileData?.links?.length">
                      <ProfileLink
                              v-if="props.profileData?.links?.length"
                              :key="'company-www'"
                              v-model="props.profileData.links[0]"
                              :edit-mode="profileEditMode"
                              @link-error="addLinkError"
                              @link-error-remove="removeLinkError"
                              :type="'link'"></ProfileLink>
                  </template>
                  <template v-else-if="userInfo.companyData?.links?.length">
                      <ProfileLink
                              @link-error="addLinkError"
                              @link-error-remove="removeLinkError"
                              :key="'company-www'"
                              :icon="`/img/socials/web.png`"
                              v-model="userInfo.companyData.links[0]"
                              :edit-mode="profileEditMode"
                              :type="'link'"/>
                  </template>
                  <template v-else>
                      <ProfileLink
                              v-if="(wwwLink as any)?.length"
                              :key="'company-www'"
                              :value="`//${wwwLink}`"
                              :edit-mode="profileEditMode"
                              :type="'link'"
                              @link-error="addLinkError"
                              @link-error-remove="removeLinkError"
                              @input="updateWWW"></ProfileLink>
                  </template>
              </div>

                            <template
                      v-if="props.profileData?.phone || props.profileData?.phoneNumber">
                  <div class="profile__header--phone">
                      <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="28"
                              height="28"
                              viewBox="0 0 28 28"
                              fill="none">
                          <path
                                  d="M5.8865 18.544L5.88625 18.5437C3.68443 15.8982 2.19772 13.4163 1.21166 10.74C0.568917 9.00899 0.316633 7.56551 0.425164 6.2003L0.425215 6.19966C0.517716 5.09545 0.964072 4.13927 1.74981 3.35353L3.84223 1.26111L3.84476 1.25857L3.84479 1.25861C4.46652 0.66593 5.18478 0.35 5.94 0.35C6.69993 0.35 7.41278 0.665237 8.01283 1.25298C8.39586 1.60795 8.78368 2.00144 9.15265 2.3816C9.15267 2.38161 9.15268 2.38163 9.1527 2.38165L9.16768 2.39707C9.35272 2.58755 9.53201 2.77212 9.72179 2.9619L11.3885 4.62863C11.3886 4.6287 11.3887 4.62877 11.3887 4.62884C12.0211 5.25547 12.3617 5.99135 12.3617 6.74927C12.3617 7.50782 12.015 8.24348 11.389 8.86943C11.2154 9.04302 11.0429 9.21558 10.876 9.38798L10.8755 9.3885C10.4239 9.85072 9.95476 10.3256 9.45519 10.7823C9.821 11.6001 10.3393 12.4129 11.1034 13.3802C12.678 15.3107 14.3221 16.8095 16.13 17.9575L16.1301 17.9576C16.3075 18.0704 16.5081 18.1737 16.7321 18.2856L16.7338 18.2865C16.8803 18.3597 17.0373 18.4382 17.1933 18.5242L19.1157 16.6018C19.7261 15.9914 20.4508 15.6571 21.2135 15.6571C21.976 15.6571 22.6957 15.9913 23.29 16.6084C23.2903 16.6087 23.2906 16.6091 23.2909 16.6094L26.6513 19.9698C27.2766 20.595 27.5973 21.3268 27.5988 22.0721C27.6003 22.8171 27.2828 23.558 26.6648 24.2022C26.6647 24.2022 26.6647 24.2023 26.6647 24.2023L26.5565 24.0984C26.2991 24.367 26.0306 24.6299 25.7676 24.8817L5.8865 18.544ZM5.8865 18.544C8.56299 21.7434 11.7856 24.2632 15.4639 26.0461L15.4651 26.0467C16.8617 26.7085 18.7461 27.5023 20.8514 27.6385L20.8514 27.6385L20.8545 27.6387L20.8712 27.6394C20.9934 27.6447 21.1147 27.65 21.2415 27.65C22.6736 27.65 23.8322 27.1534 24.7732 26.133C24.7786 26.1278 24.7954 26.1107 24.8104 26.0879C25.1054 25.7331 25.4382 25.4102 25.794 25.0651C25.8198 25.04 25.8458 25.0149 25.8718 24.9896L5.8865 18.544ZM6.84007 2.46258L6.83995 2.4627L6.84517 2.46753C7.16737 2.76569 7.47284 3.07629 7.7972 3.4061C7.84684 3.45657 7.89692 3.50749 7.94757 3.55889C8.04301 3.65713 8.13978 3.75531 8.2368 3.85373L8.23875 3.8557C8.33538 3.95372 8.43227 4.052 8.5291 4.1516L8.52909 4.15161L8.53058 4.1531L10.1978 5.82032C10.5289 6.15142 10.6798 6.46798 10.6798 6.76046C10.6798 7.05295 10.5289 7.36951 10.1978 7.70061C10.1107 7.78772 10.0236 7.87617 9.93709 7.96412L9.9368 7.96441L9.93673 7.96448C9.84997 8.05264 9.76369 8.14031 9.67749 8.22651L9.67693 8.22708C9.63783 8.26659 9.59896 8.30592 9.56026 8.34507C9.08275 8.82812 8.63263 9.28345 8.13999 9.71965L8.13981 9.71944L8.13336 9.72589L8.11937 9.73987L8.10539 9.75386C7.85185 10.0074 7.73695 10.2641 7.70661 10.5109C7.67674 10.7539 7.7307 10.9732 7.78941 11.1494C7.79362 11.162 7.79781 11.1725 7.80054 11.1793L7.80084 11.18C7.80196 11.1829 7.80284 11.1851 7.80357 11.1869C7.80469 11.1898 7.80545 11.1919 7.8062 11.1941L7.80582 11.1943L7.81002 11.2043C8.24738 12.2551 8.85413 13.2517 9.79484 14.4346L9.79483 14.4346L9.79572 14.4357C11.4827 16.5164 13.2622 18.1334 15.2243 19.3795C15.4318 19.5146 15.652 19.6259 15.8559 19.729C15.8966 19.7495 15.9366 19.7698 15.9757 19.7898L15.9769 19.7904C16.2009 19.9024 16.4016 20.0056 16.5789 20.1185L16.5854 20.1226L16.5924 20.1261C16.5993 20.1296 16.6057 20.1332 16.6158 20.1389L16.6166 20.1394C16.6259 20.1447 16.6385 20.1519 16.6531 20.1592C16.8563 20.2638 17.0585 20.3154 17.2637 20.3154C17.7764 20.3154 18.1055 19.9889 18.2033 19.891L20.2958 17.7986C20.6022 17.4922 20.9187 17.3446 21.2135 17.3446C21.5767 17.3446 21.8864 17.5712 22.0939 17.7946L22.0938 17.7946L22.0978 17.7987L25.4713 21.1666C25.4713 21.1666 25.4714 21.1666 25.4714 21.1667C25.7881 21.4834 25.9291 21.7966 25.9267 22.0992C25.9243 22.4031 25.7772 22.7278 25.4524 23.0658L25.4509 23.0674C25.2189 23.3159 24.9752 23.5542 24.7128 23.8055L24.712 23.8062C24.6902 23.8274 24.6683 23.8486 24.6464 23.8699C24.2766 24.2289 23.8882 24.6058 23.5346 25.0287C22.9217 25.6882 22.1966 25.9961 21.2471 25.9961C21.1571 25.9961 21.0607 25.9908 20.9654 25.9852C19.1607 25.8695 17.4762 25.1644 16.1983 24.5562C12.7381 22.8816 9.70048 20.5061 7.17963 17.49C5.10151 14.9884 3.70704 12.6644 2.78539 10.1771L2.7852 10.1766C2.2138 8.65098 2.00223 7.43762 2.08926 6.34237C2.15341 5.6332 2.42364 5.04532 2.93542 4.53354L5.01571 2.45325C5.31967 2.16013 5.64185 2.0207 5.94 2.0207C6.23087 2.0207 6.54133 2.1586 6.84007 2.46258Z"
                                  fill="#353535"
                                  stroke="#353535"
                                  stroke-width="0.3"/>
                      </svg>
                      <div v-if="profileEditMode" class="border border-black rounded-lg">
                          <input
                                  v-model="userPhone"
                                  type="text"
                                  class="bg-transparent w-full"/>
                      </div>
                      <p v-else>
                          {{ props.profileData?.phone || props.profileData?.phoneNumber }}
                      </p>
                  </div>
              </template>
              <div v-if="!props.readOnly" class="mx-[10px] my-3">
                  <button type="button" class="btn btn-primary w-full" @click.prevent="() => (profileEditMode = true)">{{ $t('EDIT_PROFILE') }}</button>
              </div>
              <div v-if="isUserRole(UserRole.MANAGER)" class="mx-[10px]">
                  <button type="button" class="btn btn-primary w-full" @click="editSellerManagerProfile()">{{ $t('EDIT_MANAGER_SALESREP_PROFILE') }}</button>
              </div>
              <div class="m-4">
                  <button
                          v-if="profileEditMode"
                          type="button"
                          class="btn btn-warning w-full save-profile-btn"
                          @click="save">
                      {{ $t('COMMON.SAVE_CHANGES') }}
                  </button>
              </div>
          </div>

          <template
                  v-if="!props.profileData || props.showAs === UserRole.SALES_REP">
              <div v-if="!isUserRole(UserRole.SALES_REP)" class="profile__navigation">
                  <div class="profile__navigation-list">
                      <template v-if="isUserRole(UserRole.ADMIN)">
                          <NuxtLinkLocale
                                  to="/admin/profiles"
                                  class="profile__navigation-list-item">
                              <ProvocationIcon/>
                              <p>{{ $t('HITCH_PROFILES') }}</p>
                          </NuxtLinkLocale>
                          <NuxtLinkLocale
                                  to="/admin/company"
                                  class="profile__navigation-list-item">
                              <AllCompanyAccountsIcon/>
                              <p>{{ $t('ALL_COMPANY_PROFILES') }}</p>
                          </NuxtLinkLocale>
                          <NuxtLinkLocale
                                  to="/admin/premium"
                                  class="profile__navigation-list-item">
                              <PremiumOrdersIcon/>
                              <p>{{ $t('PREMIUM_REPORTS') }}</p>
                          </NuxtLinkLocale>
                          <NuxtLinkLocale
                                  to="/admin/users"
                                  class="profile__navigation-list-item">
                              <NewUsersIcon/>
                              <p>{{ $t('ALL_NEW_USERS') }}</p>
                          </NuxtLinkLocale>
                          <NuxtLinkLocale
                                  to="/admin/consents"
                                  class="profile__navigation-list-item">
                              <ConsentsIcon/>
                              <p>{{ $t('CONSENTS.NAME') }}</p>
                          </NuxtLinkLocale>
                          <NuxtLinkLocale
                                  class="profile__navigation-list-item"
                                  to="/admin/payments">
                              <PaymentsIcon/>
                              <p>{{ $t('PAYMENTS') }}</p>
                          </NuxtLinkLocale>
                      </template>
                      <template v-else-if="isUserRole(UserRole.MANAGER)">
                          <NuxtLinkLocale
                                  to="/manager/profile"
                                  class="profile__navigation-list-item">
                              <ProvocationIcon/>
                              <p>{{ $t('PROFILE') }}</p>
                          </NuxtLinkLocale>
                          <NuxtLinkLocale
                                  to="/manager/team"
                                  class="profile__navigation-list-item">
                              <AllCompanyAccountsIcon/>
                              <p>{{ $t('TEAM') }}</p>
                          </NuxtLinkLocale>
                          <NuxtLinkLocale
                                  to="/manager/leads"
                                  class="profile__navigation-list-item">
                              <PremiumOrdersIcon/>
                              <p>{{ $t('LEADS') }}</p>
                          </NuxtLinkLocale>
                          <NuxtLinkLocale
                                  to="/manager/consents"
                                  class="profile__navigation-list-item">
                              <ConsentsIcon/>
                              <p>{{ $t('CONSENTS.NAME') }}</p>
                          </NuxtLinkLocale>
                          <NuxtLinkLocale
                                  to="/manager/integrations"
                                  class="profile__navigation-list-item">
                              <NewUsersIcon/>
                              <p>{{ $t('INTEGRATIONS') }}</p>
                          </NuxtLinkLocale>
                      </template>
                      <template v-else-if="props.showAs === UserRole.SALES_REP">
                          <transition-fade>
                              <button
                                      v-if="
                  (isUserRole([UserRole.CLIENT]) &&
                  clientHasAddedThisSalesRep !==
                    ProfileToSalesRepStatus.LOADING) || !authenticated
                "
                                      type="button"
                                      class="profile__navigation-list-item meet-me__button"
                                      :class="[
                  { 'meet-me__button--init': !isContactAdded },
                  { 'meet-me__button--added': isContactAdded },
                ]"
                                      @click="addToContacts(isContactAdded)">
                                  <template v-if="!isContactAdded">
                                      <MeetMeInitIcon/>
                                      <p>{{ $t('CHAT.MEET') }}</p>
                                  </template>
                                  <template v-else>
                                      <MeetMeAddedIcon/>
                                      <p>{{ $t('CHAT.MEET_ADDED') }}</p>
                                  </template>
                              </button>
                          </transition-fade>
                          <button
                                  v-if="authenticated"
                                  type="button"
                                  class="profile__navigation-list-item"
                                  @click.prevent="
                goToChatPage(props.profileData?.cognitoOwnerId)
              ">
                              <ChatIcon/>
                              <p>{{ $t('CHAT.NAME') }}</p>
                          </button>
                      </template>
                  </div>
              </div>

              <template
                      v-if="
          isUserRole(UserRole.SALES_REP) || props.showAs === UserRole.SALES_REP
        ">
                  <ProfileInfoWrapper
                          :profile-data="isUserRole(UserRole.SALES_REP) ? salesRepCompanyData : profileData"
                          :read-only="true"
                          :is-info="true"/>
              </template>
          </template>
      </template>
      <template v-else>
          <div class="grid place-items-center my-10">
              <Loader/>
          </div>
      </template>
  </div>
</template>
<script setup lang="ts">
import OrangeLine from '~/assets/img/profile/profile_line_orange.svg?skipsvgo'
import BlueLine from '~/assets/img/profile/profile_line_blue.svg?skipsvgo'
import PaymentsIcon from '~/assets/img/icons/menu/payments.svg?skipsvgo'
import ConsentsIcon from '~/assets/img/icons/menu/consents.svg?skipsvgo'
import ProvocationIcon from '~/assets/img/icons/menu/provocation.svg?skipsvgo'
import NewUsersIcon from '~/assets/img/icons/menu/new_users.svg?skipsvgo'
import PremiumOrdersIcon from '~/assets/img/icons/menu/premium_orders.svg?skipsvgo'
import AllCompanyAccountsIcon from '~/assets/img/icons/menu/all_company_accounts.svg?skipsvgo'
import ChatIcon from '~/assets/img/icons/conversation.svg?skipsvgo'
import MeetMeInitIcon from '~/assets/img/icons/meet-me__init.svg?skipsvgo'
import MeetMeAddedIcon from '~/assets/img/icons/meet-me__added.svg?skipsvgo'
import EditIcon from '~/assets/img/icons/edit_button.svg?skipsvgo'
import RatingIcon from '~/assets/img/icons/star.svg?skipsvgo'

import {type ComputedRef, nextTick, ref, type Ref, defineAsyncComponent, computed} from 'vue'
import {useManagerStore} from '~/stores/managerStore'
import {useModal} from 'vue-final-modal'
import AvatarEdit from '~/components/Modal/AvatarEdit.vue'
import ProfileBadge from '~/components/shared/ProfileBadge.client.vue'
import {UserRole} from '~/types/userRole'
import {useUserStore} from '~/stores/userStore'
import Loader from './shared/Loader.vue'
import {findChatRoomByOppositeUserId, isUserRole} from '~/composables/utils'
import type {SocialLink} from '~/types'
import {useAuthFetch} from '~/composables/useAuthFetch'
import {AppEvents} from '~/types/events'
import {ResponseStatus} from '~/types/responseStatus'
import {useChatStore} from '~/stores/chatStore'
import {ShowAs} from "../types/showAs";
import {TransitionFade} from "@morev/vue-transitions";
import {storeToRefs} from "pinia";
import SellerManagerProfile from "./Modal/SellerManagerProfile.vue";
import TextEditor from "./shared/TextEditor.vue";

const AvatarComponent = defineAsyncComponent(() => import('~/components/shared/AvatarComponent.vue'))
const MeetMeSuccess = defineAsyncComponent(() => import("./Modal/MeetMeSuccess.vue"))
const ProfileLink = defineAsyncComponent(() => import("./ProfileLink.vue"))
const ProfileInfoWrapper = defineAsyncComponent(() => import("./ProfileInfoWrapper.vue"))

const {$event, $listen, $toast} = useNuxtApp()
const localePath = useLocalePath()

const {t: $t} = useI18n()
const {locale} = useI18n()
const {logoutUser} = useAuthStore()

const currentLocale = locale.value

const router = useRouter()

function logout() {
  logoutUser()

  router.push(localePath('/logout'))
}

const isAddingToContactsLoading = ref(false)

async function addToContacts(isAdded = false) {
  if (!authenticated.value) {
      $toast.info($t('LOG_IN_TO_CONTINUE'))
      router.push(localePath("/login"));
      return
  }
  if (isAddingToContactsLoading.value) return

  const route = useRoute()
  const salesRepCognitoId = route.params?.id
  isAddingToContactsLoading.value = true

  if (isAdded) {
      const {data, status, error} = await useAuthFetch(
          `/newsletter/${userInfo.value.userId}/remove/${salesRepCognitoId}`,
          {
              method: 'DELETE',
              onResponse() {
              },
          }
      )
      if (status.value === ResponseStatus.SUCCESS) {
          $toast.success($t('NEWSLETTER.SUBSCRIBE.DELETE'))
          $event(AppEvents.FETCH_CONTACTS)
          isContactAddedToContacts()
          isAddingToContactsLoading.value = false
      }
      return
  }
  const {data, status, error} = await useAuthFetch(
      `/newsletter/${userInfo.value.userId}/subscribe/${salesRepCognitoId}`,
      {
          method: 'POST',
          onResponse() {
          },
      }
  )

  if (status.value === ResponseStatus.SUCCESS) {
      const {open: openSuccessModalAfterAddedToMeet} = useModal({
          component: MeetMeSuccess,
      })
      openSuccessModalAfterAddedToMeet()
      $event(AppEvents.FETCH_CONTACTS)
      isContactAddedToContacts()
      isAddingToContactsLoading.value = false
  }
}

const salesRepCompanyData = computed(() => ({
  companyName:
      userInfo.value?.companyData?.name || props.profileData?.companyData?.name,
  description:
      userInfo.value?.companyData?.description ||
      props.profileData?.companyData?.description,
  image:
      userInfo.value?.companyData?.image || props.profileData?.companyData?.image,
  opinions:
      userInfo.value?.salesRepData?.opinions?.length ||
      props.profileData?.salesRepData?.opinions?.length,
  rating:
      userInfo.value?.salesRepData?.rating ||
      props.profileData?.salesRepData?.rating,
  teamSize:
      userInfo.value?.companyData?.teamSize ||
      props.profileData?.companyData?.teamSize,
}))


const props = defineProps({
  showAs: {
      type: String || null,
      default: null,
  },
  viewFrom: {
      type: String || null,
      default: null,
  },
  readOnly: {
      type: Boolean,
      default: false,
  },
  profileData: {
      type: Object,
      default: null,
  },
  isInfo: {
      type: Boolean,
      default: false,
  },
  userProfileData: {
      type: Object,
      default: () => ({}),
  }
})

enum ProfileToSalesRepStatus {
  ADDED = 'added',
  NOT_ADDED = 'notAdded',
  LOADING = 'loading',
}

const showCompanyEditBadge = ref(false)
const {startChat} = useStore()
const userStore = useUserStore()
const {fetchUserProfileData, setProfilePhoto, fetchContacts} = userStore
const {fetchChats} = useChatStore()
const {userInfo, companyBadge}: { userInfo: Ref<any>, companyBadge: Ref<any> } = storeToRefs(userStore)

const store = useManagerStore()
const {authenticated} = storeToRefs(useAuthStore())

const profileDescription = ref('')

const userSocials = computed(() => {
  return (userInfo.value.companyData?.socials as SocialLink[]) || []
})

const isProfileLoading = ref(true)
const linkErrors = ref(new Set([]))

function addLinkError(event){
  console.log(event)
  linkErrors.value.add(event)
}

function removeLinkError(event){
  console.log(event)
  linkErrors.value.delete(event)
}

const wwwLink = computed(() => ({
  get() {
      if (props.showAs === UserRole.SALES_REP) {
          return props.profileData.links[0] ?? ''
      }
      return userInfo.value.companyData.links[0] ?? ''
  },
  set(value) {
      console.log('value', value)
      userInfo.value.companyData.links[0] = value
  },
}))

function updateWWW(event) {
  $event('update:www-link', event.target.value)
}

$listen('update:www-link', value => {
  userInfo.value.companyData.links[0] = value
})

$listen('change-avatar-photo', () => {
  fetchUserProfileData({
      onResponseCallback: async ({response}) => {
          console.log(response._data)

          await nextTick(() => {
              userInfo.value.promos = response._data.promos
          })
      },
  })
})

const clientHasAddedThisSalesRep = ref(ProfileToSalesRepStatus.LOADING)

async function isContactAddedToContacts() {
  const route = useRoute()
  const salesRepCognitoId = route.params?.id
  if (!salesRepCognitoId) {
      return
  }

  const {data, status, error} = await useAuthFetch(
      `/newsletter/${userInfo.value.userId}/info/${salesRepCognitoId}`,
      {
          method: 'GET',
          onResponse() {
          },
      }
  )

  clientHasAddedThisSalesRep.value = data.value.isContactAdded
      ? ProfileToSalesRepStatus.ADDED
      : ProfileToSalesRepStatus.NOT_ADDED
}

const isContactAdded = computed(() => {
  return clientHasAddedThisSalesRep.value === ProfileToSalesRepStatus.ADDED
})

const socialLinks = computed(() => {

  const defaultLinks = isUserRole.value([UserRole.MANAGER, UserRole.SALES_REP])
      ? [
          {
              type: 'Facebook',
              link: '',
          },
          {
              type: 'Instagram',
              link: '',
          },
          {
              type: 'LinkedIn',
              link: '',
          },
          {
              type: 'Spotify',
              link: '',
          },
      ]
      : []

      return defaultLinks.map(s => {
          const sIndex = userSocials.value.findIndex(
              us => us.type === s.type && !!us._id
          )
          if (sIndex !== -1) {
              return userSocials.value[sIndex]
          }
          return s
      })
})

interface User {
  description: string
  name: string
}

const user: Ref<User> = ref({
  description: '',
  name: '',
})

const salesRepTitle = computed({
  get() {
      if (isUserRole.value(UserRole.SALES_REP)) {
          if (userInfo.value?.salesRepData?.title !== undefined) {
              return userInfo.value?.salesRepData?.title
          }
          return $t('SALES_REP')
      }
      return ''
  },
  set(newValue) {
      if (isUserRole.value(UserRole.SALES_REP)) {
          if (userInfo.value?.salesRepData !== undefined) {
              userInfo.value.salesRepData.title = newValue
          }
      }
  },
})

const userName = computed({
  get() {
      if (isUserRole.value(UserRole.MANAGER)) {
          if (userInfo.value.companyData?.name !== undefined) {
              return userInfo.value.companyData?.name ?? ''
          }
      }
      if (isUserRole.value(UserRole.SALES_REP)) {
          if (
              userInfo.value?.salesRepData?.firstName !== undefined &&
              userInfo.value?.salesRepData?.lastName !== undefined
          ) {
              const firstName = userInfo.value.salesRepData?.firstName ?? ''
              const lastName = userInfo.value.salesRepData?.lastName ?? ''

              return `${firstName} ${lastName}`
          }
      }
      /*
          Brak backendu, więc trzeba zrobic finalnie analogicznie jak wyżej
       */
      if (isUserRole.value(UserRole.CLIENT)) {
          if (props.profileData?.firstName !== undefined) {
              const firstName = props.profileData?.firstName ?? ''
              const lastName = props.profileData?.lastName ?? ''
              return `${firstName} ${lastName}`
          }
      }
      const firstName = props.profileData?.firstName ?? ''
      const lastName = props.profileData?.lastName ?? ''
      return `${firstName} ${lastName}`
  },
  set(newValue) {
      if (isUserRole.value(UserRole.MANAGER)) {
          if (userInfo.value.companyData.name !== undefined) {
              userInfo.value.companyData.name = newValue
          }
      }
      if (isUserRole.value(UserRole.SALES_REP)) {
          if (
              userInfo.value?.salesRepData?.firstName !== undefined &&
              userInfo.value?.salesRepData?.lastName !== undefined
          ) {
              userInfo.value.salesRepData.firstName = newValue?.split(' ')[0] ?? ''
              userInfo.value.salesRepData.lastName = newValue?.split(' ')[1] ?? ''
          }
      }
      if (isUserRole.value(UserRole.CLIENT)) {
          const firstName = newValue.split(' ')[0] ?? ''
          const lastName = newValue.split(' ')[1] ?? ''
          if (
              userInfo.value.firstName !== undefined &&
              userInfo.value.lastName !== undefined
          ) {
              userInfo.value.firstName = firstName
              userInfo.value.lastName = lastName
          }
      }
  },
})

const userDescription = computed({
  get() {
      if (isUserRole.value(UserRole.MANAGER)) {
          if (userInfo.value.companyData?.description !== undefined) {
              return userInfo.value.companyData?.description
          }
      }

      if (isUserRole.value(UserRole.SALES_REP)) {
          if (userInfo.value.salesRepData?.description !== undefined) {
              return userInfo.value.salesRepData?.description
          }
      }
      /*
          Brak backendu, więc trzeba zrobic finalnie analogicznie jak wyżej
       */
      if (isUserRole.value(UserRole.CLIENT)) {
          if (props.profileData?.description !== undefined) {
              return props.profileData?.description
          }
      }
      return ''
  },
  set(newValue) {
      if (isUserRole.value(UserRole.MANAGER)) {
          if (userInfo.value.companyData.description !== undefined) {
              userInfo.value.companyData.description = newValue
          }
      }
      if (isUserRole.value(UserRole.SALES_REP)) {
          if (userInfo.value.salesRepData?.description !== undefined) {
              userInfo.value.salesRepData.description = newValue
          }
      }
  },
})

const userPhone = computed({
  get() {
      if (isUserRole.value(UserRole.MANAGER)) {
          if (userInfo.value.companyData?.description !== undefined) {
              return userInfo.value.companyData?.description
          }
      }

      if (isUserRole.value(UserRole.SALES_REP)) {
          if (userInfo.value.salesRepData?.description !== undefined) {
              return userInfo.value.salesRepData?.description
          }
      }
      /*
              Brak backendu, więc trzeba zrobic finalnie analogicznie jak wyżej
           */
      if (isUserRole.value(UserRole.CLIENT)) {
          if (props.profileData?.phoneNumber !== undefined) {
              return userInfo.value.phoneNumber
          }
      }
      return ''
  },
  set(newValue) {
      if (isUserRole.value(UserRole.MANAGER)) {
          if (userInfo.value.companyData.description !== undefined) {
              userInfo.value.companyData.description = newValue
          }
      }
      if (isUserRole.value(UserRole.SALES_REP)) {
          if (userInfo.value.salesRepData?.description !== undefined) {
              userInfo.value.salesRepData.description = newValue
          }
      }

      if (isUserRole.value(UserRole.CLIENT)) {
          console.log(newValue, userInfo.value)
          if (userInfo.value.phoneNumber !== undefined) {
              userInfo.value.phoneNumber = newValue
          }
      }
  },
})

const profileEditMode = ref(false)

const currentEditField = ref('')

function focusField(name: string) {
  currentEditField.value = name
}

function blurField() {
  //currentEditField.value = ''
}

function isFieldEditable(name: keyof User) {
  return user.value[name] && currentEditField.value === name
}

function updateValue(name: string, value: string) {
  if (name === 'description') {
      profileDescription.value = value
  }
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function selectProfilePhoto(event: Event) {
  const target = event.target as HTMLInputElement

  //userInfo.value.companyData.image = target.files[0] as File
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  setProfilePhoto(target.files[0] as File)

  // updatePhoto(event).then((result: string) => {
  //   updateProfileInfo('image', result)
  // })
}

async function updateSocialLink(socialLinkData) {
  await useAuthFetch(`/managers/${userInfo.value.cognitoOwnerId}/socials`, {
      method: 'PUT',
      body: socialLinkData,
      onResponse() {
      },
  })
}

async function goToChatPage(uId) {
  const router = useRouter()
  const localePath = useLocalePath()

  const chatListResponse = await fetchChats()
  const result = findChatRoomByOppositeUserId(chatListResponse, uId)
  let roomId = null

  if (!result?._id) {
      roomId = await startChat(uId)
  } else {
      roomId = result?._id
  }

  if (roomId) {
      window.location.href = `/${locale.value}/chat/${roomId}`
  }
}

async function save() {
  if (linkErrors.value.size > 0) {
      $toast.info('FIX_LINK')
      return
  }
  if (!isUserRole.value([UserRole.SALES_REP, UserRole.CLIENT])) {
      for (const slData of socialLinks.value) {
          await updateSocialLink(slData)
      }
  }

  let endpointRoute = 'managers'
  let userId = userInfo.value.cognitoOwnerId

  let bodyData: any = {
      firstName: userName.value.split(' ')[0] ?? '',
      lastName: userName.value.split(' ')[1] ?? '',
      description: userDescription.value,
      links: userInfo.value.companyData?.links,
  }
  if (isUserRole.value([UserRole.MANAGER])) {
      endpointRoute = 'managers'
      bodyData = {
          title: salesRepTitle.value,
          name: userName.value,
          description: userDescription.value,
          links: [userInfo.value.companyData?.links[0] ?? ''],
          companyTitleId: companyBadge.value?._id
      }
  }
  if (isUserRole.value([UserRole.SALES_REP])) {
      endpointRoute = 'companies/salesreps'
      bodyData = {
          title: salesRepTitle.value,
          firstName: userName.value.split(' ')[0] ?? '',
          lastName: userName.value.split(' ')[1] ?? '',
          description: userDescription.value,
          links: [],
      }
  }
  if (isUserRole.value([UserRole.CLIENT])) {
      endpointRoute = 'users'
      bodyData = {
          firstName: userName.value.split(' ')[0] ?? '',
          lastName: userName.value.split(' ')[1] ?? '',
          description: userDescription.value,
          phoneNumber: userPhone.value,
      }
      userId = userInfo.value.cognitoUserId
  }

  useAuthFetch(`/${endpointRoute}/${userId}/data`, {
      method: 'PUT',
      body: bodyData,
      onResponse() {
          $event(AppEvents.FETCH_USER_DATA)
      },
  })

  store.updateProfileInfo({data: userInfo.value})
  profileEditMode.value = false
}

function toggleEditProfile() {
  profileEditMode.value = !profileEditMode.value
}

function openModal() {
  if (profileEditMode.value) {
      const {open} = useModal({
          component: AvatarEdit,
          attrs: {
              image: userInfo.value.image,
              onUpdateImage: newImage => {
                  ;(userInfo as any).value.image = newImage
              },
          },
      })
      open()
  }
}

function editSellerManagerProfile() {
    const {open} = useModal({
        component: SellerManagerProfile,
    })
    open()
}

onMounted(() => {
  if (authenticated.value) {
      fetchUserProfileData({
          onResponseCallback() {
              setTimeout(async () => {
                  await isContactAddedToContacts()
              }, 0)
              isProfileLoading.value = false
          },
      })
      if (isUserRole.value([UserRole.MANAGER])) {
          showCompanyEditBadge.value = true;
      }
  }
  if (props.profileData) {
      isProfileLoading.value = false
  }
})

onUpdated(() => {
  if (props.profileData) {
      isProfileLoading.value = false
  }
})
const userAvatarFromProps = toRef(() => {
  if (props.showAs !== UserRole.SALES_REP) {
      return props.profileData?.companyData?.image || props.profileData.image || props.profileData.avatar
  } else {
      return props.profileData.image || props.profileData.avatar
  }
})

const userAvatar = computed({
  get: function () {
      if (isUserRole.value(UserRole.MANAGER)) {
          if (userInfo.value.companyData?.image !== undefined) {
              return userInfo.value.companyData?.image
          }
      }

      if (isUserRole.value(UserRole.SALES_REP)) {
          if (userInfo.value.salesRepData?.image !== undefined) {
              return userInfo.value.salesRepData?.image
          }
      }
      if (isUserRole.value(UserRole.CLIENT)) {
          if (userInfo.value?.avatar !== undefined) {
              return userInfo.value.avatar
          }
      }
      return ''
  },
  set(newValue) {
      if (isUserRole.value(UserRole.MANAGER)) {
          if (userInfo.value.companyData.image !== undefined) {
              userInfo.value.companyData.image = newValue
          }
      }
      if (isUserRole.value(UserRole.SALES_REP)) {
          if (userInfo.value.salesRepData?.image !== undefined) {
              userInfo.value.salesRepData.image = newValue
          }
      }
      if (isUserRole.value(UserRole.CLIENT)) {
          if (userInfo.value?.avatar !== undefined) {
              userInfo.value.avatar = newValue
          }
      }
  },
})

const profileInfoActiveColors = computed(() => {
  if (isUserRole.value([UserRole.ADMIN, UserRole.MANAGER])) {
      return {
          text: '#fff',
          background: '#FFA800FF',
      }
  }
  return {
      text: '#fff',
      background: '#3870FF',
  }
})

const isVerified = computed(() => {
  // Loged Manager case
  if (isUserRole.value([UserRole.MANAGER]) && !props.showAs) {
    return userInfo.value.companyData?.isVerified
  }
  // Logged Client on SalesRep profile
  if (isUserRole.value([UserRole.CLIENT]) && !props.showAs && props.profileData?.companyData?.isVerified) {
    return props.profileData?.companyData?.isVerified
  }
  return false
})

</script>
<style lang="scss" scoped>
@use '@/assets/scss/abstracts/mixins';

/*MENU RIGHT SITE*/
.preview-elements {
display: flex;
justify-content: center;
align-items: center;
width: 100%;
height: 56%;
background: #fff;
border-radius: 20px;
border: 1px solid #e5e5e5;
opacity: 0.4;
}

.preview-elements p {
color: #000;
font-weight: 900;
}

/*-----------------*/
.profile_manager_section {
background: #fff;
min-height: 160vh;
display: block;
margin: 25px 0;
}

.content-profile-manager {
display: flex;
margin: 0px 50px 10px 50px;
gap: 20px;
}

.meet-me__button {
display: flex;
flex-direction: column;
border-radius: 20px;
padding: 30px 80px !important;
color: var(--text-color, #fff) !important;
background-color: var(--bg-color) !important;

&--init {
  --bg-color: #353535;
}

&--added {
  --bg-color: #3870ff;
}
}

.profile {
height: 100%;
border-radius: 20px;
background: rgba(255, 255, 255, 0.7);
backdrop-filter: blur(2px);
background: url('~/assets/img/profile/profile_manager_background_01.png') top left /
    contain no-repeat,
url('~/assets/img/profile/profile_manager_background_02.png') bottom right /
    contain no-repeat;
border: solid 1px #e1e1e1;
--btn-text-color: #fff;
--btn-bg-color: #ffa800;

&--blue {
  --btn-text-color: #fff;
  --btn-bg-color: #3870ff;
  background: url('@/assets/img/profile/profile_salesman_background.png');
  background-repeat: no-repeat;
  background-size: cover;
}

&--loading {
  position: relative;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: inherit;
    z-index: 100;
    background: rgb(255, 255, 255);
    background: linear-gradient(
                    130deg,
                    #ffa800 0%,
                    #ffffff 50%,
                    #3870ff 100%
    );
    background-size: 200% 200%;
    animation: loadingGradient 1s ease infinite;
  }
}

&.is-info {
  background: #f6f6f6;
  height: auto;
}

&__line {
  display: flex;
  align-items: center;
  gap: 15px;
  padding-top: 20px;
}

&__img {
  display: flex;
  justify-content: center;
  padding: 15px 0px;
  position: relative;

  img {
    @include mixins.maskAvatar(212px);
  }

  &-edit-btn {
    /**
    TRZEBA ZROBIĆ WSPOLNĄ KLASĘ, ALBO KOMPONENT
     */
    --bg-color: #fff;
    --fill-color: var(--bg-color);
    --padding: 50px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background-color: #fff;
    background-color: var(--bg-color);
    padding: 50px;
    padding: var(--padding);
    border-radius: 50%;
    cursor: pointer;
    transition: background-color 0.15s ease;

    &:hover {
      --bg-color: #e1e0e0;
    }
  }
}

.save-profile-btn {
  --bg-color: var(--btn-bg-color);
  --text-color: var(--btn-text-color);
  --stroke-color: var(--btn-text-color);
}

&__name {
  display: flex;
  justify-content: center;
  padding: 5px;

  p,
  input {
    color: #353535;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 25px;
    text-align: center;
    background: transparent;
  }
}

&__company {
  display: flex;
  justify-content: center;
  padding: 5px;
  border-radius: 20px;

  p {
    color: rgba(53, 53, 53, 0.5);
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 25px;
  }
}

&__opinion {
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding-top: 20px;
  gap: 8px;

  &-rate {
    color: #353535;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 25px;
  }

  &-summary {
    color: rgba(53, 53, 53, 0.5);
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 25px;
  }
}

&__desc {
  margin: 0 45px;
  padding: 20px 0px;

  p {
    color: #353535;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 25px;
  }
}

&__navigation {
  margin: 70px 10px 25px 10px;

  &-list {
    display: flex;
    flex-direction: column;
    gap: 15px;

    &-item {
      display: flex;
      padding: 15px 0;
      border-radius: 20px;
      background: #f6f6f6;
      justify-content: center;
      align-content: center;
      align-items: center;
      gap: 13px;
      color: #353535;

      &.router-link-active {
        background: #353535;
        border-radius: 20px;
        color: #fff;

        svg {
          --fill-color: #fff;
        }
      }

      &:hover {
        background: #353535;
        border-radius: 20px;
        color: #fff;

        svg {
          --fill-color: #fff;
        }
      }

      p {
        font-size: 18px;
        font-style: normal;
        font-weight: 700;
      }

      &--active {
        background: #353535;
        border-radius: 20px;
        border: 1px solid #333;
        color: #fff;
      }
    }
  }
}

&__social {
  display: flex;
  padding: 14px 30px;
  border-radius: 20px;
  background: #f6f6f6;
  margin: 0px 15px;
  justify-content: space-around;

  &-icon {
    width: 36px;
    height: 36px;
    @media screen and (max-width: 1280px) {
      width: 28px;
      height: 28px;
    }
  }

  /* ROLES */
  &--sales-rep {
    background: transparent;
  }
}

&__footer {
  //margin: 35px 15px 15px 40px;
}

&__link {
  display: flex;
  padding: 8px 0;
  align-items: center;
  gap: 11px;
  //justify-content: space-between;
  p,
  input {
    color: #353535;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 30px;
    width: 100%;
  }
}

.button-arrow,
.button-delete {
  display: flex;
  padding: 13px 38px;
  justify-content: center;
  align-items: center;
  border-radius: 20px;
  background: #3870ff;
}

.button-delete {
  padding: 13px 20px;
  background: #353535;

  img {
    min-width: 25px;
  }
}
}

.product-slider {
margin: 15px;
}

.product-person p {
color: #353535;
font-size: 14px;
font-style: normal;
font-weight: 400;
line-height: 30px;
text-transform: uppercase;
}

.product-company p {
color: rgba(53, 53, 53, 0.5);
font-size: 14px;
font-style: normal;
font-weight: 400;
line-height: 30px;
text-transform: uppercase;
}

.product-add-time p {
color: rgba(53, 53, 53, 0.5);
font-size: 14px;
font-style: normal;
font-weight: 400;
line-height: 30px;
text-transform: uppercase;
text-align: right;
}

.product-desc {
text-align: left;
margin: 30px 0;
}

.product-desc p {
color: #353535;
font-size: 20px;
font-style: normal;
font-weight: 700;
line-height: 30px;
}

.edit {
position: absolute;
top: 15px;
right: 15px;
z-index: 10;
cursor: pointer;

&__button {
  --bg-color: #e6e6e6;
  background-color: var(--bg-color);
  transition: all 0.2s ease;
  display: inline-block;
  border-radius: 50%;

  svg {
    --fill-color: var(--bg-color);
  }

  &--active {
    --bg-color: var(--btn-bg-color);
    --text-color: var(--btn-text-color);
    --stroke-color: var(--btn-text-color);
  }
}
}

/*
.add-product-button {
margin: 15px 0;
}
.add-product-button img {
width: 30px !important;
height: 30px !important;
}
.add-product-button p {
color: #fff;
font-size: 20px;
font-style: normal;
font-weight: 700;
line-height: 30px;
}
form#price {
display: flex;
gap: 25px;
}
input#price {
width: 100%;
align-items: center;
gap: 11px;
border-radius: 20px;
background: #f6f6f6;
}
input#price {
padding: 10px 30px;
color: #353535;
font-size: 20px;
font-style: normal;
font-weight: 700;
}
.meet-content-button {
display: flex;
justify-content: center;
align-items: center;
}
input[type='submit'] {
background: #3870ff;
color: #fff;
font-size: 20px;
font-style: normal;
font-weight: 700;
line-height: 30px;
}
.meet-content {
min-height: 225px;
margin: 15px;
display: flex;
align-items: center;
}
.opinion-content {
height: auto;
margin: 15px;
}
.product-content-slim-opinion {
border-radius: 20px;
background: linear-gradient(0deg, #3870ff 0%, #3870ff 100%), #fff;
width: 100%;
height: 100%;
display: flex;
align-items: flex-end;
justify-content: flex-start;
}

.add-product-content-slim-right {
display: flex;
flex-direction: column;
align-items: stretch;
width: 65%;
justify-content: flex-end;
}
a.add-opinion {
width: 100%;
height: 100%;
display: flex;
align-items: flex-start;
padding: 23px;
flex-direction: column;
justify-content: flex-end;
gap: 20px;
}
.opinion-desc-top p {
color: #fff;
font-size: 18px;
font-style: normal;
font-weight: 400;
line-height: 30px;
}
.opinion-desc-user p {
color: #fff;
font-size: 18px;
font-style: normal;
font-weight: 700;
line-height: 30px;
}
.opinion-content-slim {
padding: 35px 15px;
display: flex;
align-items: stretch;
gap: 15px;
height: auto;
border-radius: 20px;
background: #f6f6f6;
flex-direction: column;
justify-content: space-between;
}
.opinion-content-slim-top {
display: flex;
justify-content: space-between;
}
.opinion-add-time p {
color: rgba(53, 53, 53, 0.5);
font-size: 14px;
font-style: normal;
font-weight: 400;
line-height: 30px;
text-transform: uppercase;
text-align: right;
}
.opinion-content-slim {
gap: 5px;
}
.opionion-content-slim-bottom {
gap: 10px;
}
.opinion-user-name p {
font-size: 16px;
}
.opinion-user-text p {
font-size: 12px;
}
.opionion-content-slim-bottom {
display: flex;
gap: 28px;
flex-direction: column;
align-items: flex-start;
}
.opinion-user-name p {
color: #353535;
font-size: 20px;
font-style: normal;
font-weight: 700;
line-height: 30px;
}
.opinion-user-text p {
color: #353535;
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: 25px;
}
.meet-content-slim-special-offer {
height: auto;
margin: 15px;
}
.product-content-slim-special-offer {
border-radius: 20px;
background: rgba(255, 168, 0, 0.2);
padding: 10px;
display: flex;
align-items: stretch;
gap: 15px;
height: auto;
}
/* FAQ */
.faq {
border-radius: 20px;
background: #353535;
padding: 35px;
height: auto;
margin: 15px;
}

.accordion-item:first-of-type .accordion-button {
border-radius: 20px;
}

.accordion-item {
border-radius: 20px;
background: #f6f6f6;
margin-top: 15px;
}

.accordion-item:first-of-type {
border-radius: 20px;
}

.accordion-item:last-of-type .accordion-button.collapsed {
border-radius: 20px;
}

.accordion-item:last-of-type {
border-radius: 20px;
}

.accordion-button {
border-radius: 20px;
}

.accordion-button:not(.collapsed) {
color: #ffffff;
background-color: #353535;
box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.125);
}

.accordion-body {
background: #ffffff;
border-radius: 20px;
}

.accordion-button:focus {
box-shadow: none;
}

@media (max-width: 1496px) {
.profile {
  &__line {
    font-size: var(--font-xsmall);
  }

  &__name p {
    font-size: var(--font-small);
  }

  &__company p {
    font-size: var(--font-xsmall);
  }

  &__opinion {
    padding-top: 10px;

    p {
      font-size: var(--font-xsmall);
    }
  }

  &__desc {
    padding-top: 10px;
    margin: 0 15px;

    p {
      font-size: var(--font-exsmall);
    }
  }

  &__navigation {
    margin: 20px 10px;

    &-list {
      &-item {
        padding: 10px 0;
        gap: 10px;

        p {
          font-size: var(--font-xsmall);
        }
      }

      svg {
        width: 22px;
      }
    }
  }

  &__link {
    padding: 0;
    font-size: var(--font-xsmall);
  }
}
.edit {
  &__button {
    svg {
      width: 35px;
      height: 35px;
    }
  }
}
}

/* 1440px
@media screen and (max-width: 1440px) {
.content-profile-manager {
  margin: 30px 10px 30px 10px;
}
.left-profile-manager {
  //width: 27%;
}
.profile-header-desc {
  margin: 0 25px;
}
.backlink {
  width: 405px;
  padding: 35px 56px;
}
.product-slider {
  margin-bottom: 0px;
}
.product-info-left {
  gap: 0px;
}
.menu-item {
  width: 95px;
  height: 100px;
}
.menu-item p {
  font-size: 12px;
}
.profile-footer {
  margin: 15px;
}
.profile-links p {
  font-size: 14px;
}
.button-arrow {
  padding: 7px 28px;
}
.menu-item-manager-section p {
  font-size: 16px;
}
.menu-item-manager-section {
  padding: 12px 0;
}
.menu-item-manager p {
  font-size: 16px;
}
.menu-item-manager {
  padding: 12px 0;
}
}
*/
/*1280px
@media screen and (max-width: 1280px) {
a.social-icon {
  width: 28px;
  height: 28px;
}
a.button-meet {
  font-size: 14px;
}
.button-meet {
  padding: 12px 0px;
}
a.button-link {
  font-size: 16px;
}
.button-link {
  padding: 8px 0px;
}
.product-person p {
  font-size: 12px;
}
.product-company p {
  font-size: 12px;
}
.product-add-time p {
  font-size: 12px;
}
.product-desc p {
  font-size: 16px;
}
input#submit_price {
  width: 62px;
  height: 35px;
}
form#price {
  gap: 15px;
  height: 35px;
}
.meet-content-left {
  width: 50%;
}
.meet-content-right {
  width: 56%;
}
.meet-content-desc {
  gap: 0;
}
.meet-content-desc-first p {
  font-size: 16px;
}
.meet-content-desc-second p {
  font-size: 16px;
}
.product-info {
  margin: 0;
}
.product-desc {
  margin: 5px 0;
}
.opinion-content-slim-top {
  gap: 15px;
}
.opinion-desc-top p {
  font-size: 14px;
}
.opinion-desc-user p {
  font-size: 16px;
}
.opinion-content-slim {
  padding: 25px 15px;
}
.star-ratings p {
  font-size: 14px;
}
.opinion-add-time p {
}
}
*/

@media screen and (max-width: 768px) {
.profile__navigation-list-item {
  padding: 8px 0;
  margin-bottom: 5px;
  box-shadow: 0 5px 5px rgb(0 0 0 / 22%);
}
.profile__social {
  padding: 0;
  margin: 0;
  background: #fff;
}
.profile--blue {
  background-size: cover;
  background-repeat: no-repeat;
}
.profile {
  background: #ffffff;

  &__header {
    /*display: grid;
    grid-template-columns: 0.5fr 1fr;
    grid-template-rows: 0.5fr 0.1fr 0.1fr 0.5fr;
    gap: 10px 10px;
    grid-template-areas:
      'line line'
      'img name'
      'img phone'
      'img mail'
      'desc desc';*/
    display: flex;
    flex-direction: column;
    text-align: center;
  }

  &__company {
  }

  &__opinion {
  }

  &__line {
    grid-area: line;
  }

  &__img {
    grid-area: img;
  }

  &__name {
    grid-area: name;
    align-items: flex-end;

    p {
    }
  }

  &__desc {
    grid-area: desc;
    text-align: center;
  }

  &__header--phone {
    margin: 0 20px;
    border: 2px solid #353535;
    gap: 10px;
    font-size: 14px;
    padding: 5px;
    background: #fff;
  }

  &__separate {
    border-top: 1px solid #353535;
  }
}
.edit__button svg {
  width: 33px;
  height: 33px;
}
}

@media screen and (max-width: 576px) {
.meet-content-slim {
  height: 618px;
}
}
</style>
